import { useErrorBoundary as useErrorBoundaryReactError } from 'react-error-boundary';

const useErrorBoundary = () => {
  const { showBoundary: showBoundaryReactError } = useErrorBoundaryReactError();
  const showBoundary = (error: any) => {
    showBoundaryReactError(error);
  };
  return {
    showBoundary,
  };
};

export default useErrorBoundary;
